import React, { useEffect } from 'react';
import { Button, Drawer, Form, Input, Select, Space, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { BaseModel } from '../../../types';
import { CanvassLineRecord } from '../../../types/Canvass';
import { dateFormat } from '../../../lib/utils';

/** Adds or edits a candidate supplier -- a column of the comparison. */
const SupplierDrawer = ({
  open,
  line,
  vendors,
  onClose,
  onSave,
}: {
  open: boolean;
  line: CanvassLineRecord | null;
  vendors: BaseModel[];
  onClose: () => void;
  onSave: (v: CanvassLineRecord) => void;
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({
      vendor: line?.vendor?.id,
      paymentTerms: line?.paymentTerms,
      contactMethod: line?.contactMethod,
      quoteValidity: line?.quoteValidity ? dayjs(line.quoteValidity) : undefined,
      remarks: line?.remarks,
    });
  }, [open, line]);

  return (
    <Drawer
      title={line?.id ? 'Edit Supplier' : 'Add Candidate Supplier'}
      open={open}
      onClose={onClose}
      footer={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button type={'primary'} onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        layout={'vertical'}
        onFinish={(v) =>
          onSave({
            ...line,
            vendor: vendors.find((x) => x.id === v.vendor),
            paymentTerms: v.paymentTerms,
            contactMethod: v.contactMethod,
            quoteValidity: v.quoteValidity
              ? v.quoteValidity.format(dateFormat)
              : undefined,
            remarks: v.remarks,
          })
        }
      >
        <Form.Item
          name={'vendor'}
          label={'Supplier'}
          rules={[{ required: true, message: 'Please choose a supplier' }]}
        >
          <Select
            showSearch
            optionFilterProp={'label'}
            options={vendors.map((v) => ({ label: v.description, value: v.id }))}
          />
        </Form.Item>
        <Form.Item name={'paymentTerms'} label={'Terms of Payment'}>
          <Input />
        </Form.Item>
        <Form.Item name={'contactMethod'} label={'Contacted By'}>
          <Select
            allowClear
            options={['Call', 'Email', 'Viber', 'Messenger'].map((m) => ({
              label: m,
              value: m,
            }))}
          />
        </Form.Item>
        <Form.Item name={'quoteValidity'} label={'Quote Valid Until'}>
          <DatePicker className={'w-full'} format={dateFormat} />
        </Form.Item>
        <Form.Item name={'remarks'} label={'Remarks'}>
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SupplierDrawer;
